/* eslint-disable max-len */
export const VeOSymbolType = {
  roundSpuare:
    'M-4.3-6h8.6c0.4,0,0.9,0.2,1.2,0.5C5.8-5.2,6-4.8,6-4.3v8.6C6,5.2,5.2,6,4.3,6h-8.6C-5.2,6-6,5.2-6,4.3v-8.6C-6-5.2-5.2-6-4.3-6z',
  line: 'M-4.6-1h9.1C4.8-1,5-0.8,5-0.6v1.1C5,0.8,4.8,1,4.6,1h-9.1C-4.8,1-5,0.8-5,0.5v-1.1c0-0.1,0-0.2,0.1-0.3C-4.8-0.9-4.7-1-4.6-1z',
  linePoint:
    'M6.1-1H4.9C4.4-3.3,2.4-5,0-5c-2.4,0-4.4,1.7-4.9,4h-1.2c-0.2,0-0.4,0.2-0.4,0.4v1.1C-6.5,0.8-6.3,1-6.1,1h1.2C-4.4,3.3-2.4,5,0,5c2.4,0,4.4-1.7,4.9-4h1.2c0.2,0,0.4-0.2,0.4-0.5v-1.1C6.5-0.8,6.3-1,6.1-1z',
  linePointHollow:
    'M6.1-1H4.9C4.4-3.3,2.4-5,0-5s-4.4,1.7-4.9,4h-1.2c-0.2,0-0.4,0.2-0.4,0.4v1.1C-6.5,0.8-6.3,1-6.1,1h1.2C-4.4,3.3-2.4,5,0,5s4.4-1.7,4.9-4h1.2c0.2,0,0.4-0.2,0.4-0.5v-1.1C6.5-0.8,6.3-1,6.1-1z M0,3.2c-1.8,0-3.2-1.4-3.2-3.2S-1.8-3.2,0-3.2S3.2-1.8,3.2,0S1.8,3.2,0,3.2z',
  lineDash:
    'M-5-1h2.1c0.2,0,0.5,0.2,0.5,0.4v1.1C-2.4,0.8-2.6,1-2.9,1H-5c-0.2,0-0.4-0.2-0.4-0.5v-1.1C-5.4-0.8-5.2-1-5-1zM-1-1h2.1c0.2,0,0.4,0.2,0.4,0.4v1.1C1.5,0.8,1.3,1,1.1,1H-1c-0.2,0-0.4-0.2-0.4-0.5v-1.1C-1.5-0.8-1.3-1-1-1z M2.9-1H5c0.2,0,0.4,0.2,0.4,0.4v1.1C5.4,0.8,5.2,1,5,1H2.9C2.6,1,2.4,0.8,2.4,0.5v-1.1C2.4-0.8,2.6-1,2.9-1z',
  triangleUp: 'M0,0l3.9,6h-7.8L0,0z',
  triangleDown: 'M0,0l-3.9-6h7.8L0,0z'
};

export const VeOColor = {
  /** 致命 */
  fatal: '#7E0C06',
  /** 高危、不健康 */
  critical: '#D7312A',
  /** 中危、警告 */
  warning: '#EF7D2E',
  /** 低危，提示 */
  notice: '#F0A50F',
  /** 安全，健康 */
  safe: '#309256'
};
